// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CoverMyMedsV1ClientGeneratedCaregiverModel } from './coverMyMedsV1ClientGeneratedCaregiverModel.js';
import type { CoverMyMedsV1ClientGeneratedPatientModel } from './coverMyMedsV1ClientGeneratedPatientModel.js';
import type { CoverMyMedsV1ClientGeneratedPrescriptionDefinitionModel } from './coverMyMedsV1ClientGeneratedPrescriptionDefinitionModel.js';
import type { CoverMyMedsV1ClientGeneratedProviderModel } from './coverMyMedsV1ClientGeneratedProviderModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsV1ClientGeneratedHubEnrollmentModel {
    'substitutionsAllowed'?: boolean | null;
    'caregiver'?: CoverMyMedsV1ClientGeneratedCaregiverModel | null;
    'diagnosis'?: string | null;
    'diagnosisDate'?: Moment | null;
    'otherDiagnosis'?: string | null;
    'drugAllergies'?: string | null;
    'hasPatientRepresentative'?: boolean;
    'hcpHasPreferredSpecialtyPharmacy'?: boolean | null;
    'hcpPreferredSpecialtyPharmacy'?: string | null;
    'isEnrollmentCopayConsented'?: boolean | null;
    'isPrescriptionSentToSpecialtyPharmacy'?: boolean | null;
    'isTcpaConsented'?: boolean | null;
    'key'?: string | null;
    'medicalCardId'?: string | null;
    'medicalGroupId'?: string | null;
    'medicalInsuranceCarrier'?: string | null;
    'noKnownDrugAllergies'?: boolean | null;
    'patient'?: CoverMyMedsV1ClientGeneratedPatientModel | null;
    'patientMarketingSignatureDate'?: Moment | null;
    'patientSignatureDate'?: Moment;
    'patientCopaySignatureDate'?: Moment | null;
    'patientSignatureReceivedDate'?: Moment;
    'pdf'?: string | null;
    'preferredContact'?: string | null;
    'preferredLang'?: Array<string> | null;
    'preferredLangOther'?: string | null;
    'prescriptionBin'?: string | null;
    'prescriptionDefinitions'?: Array<CoverMyMedsV1ClientGeneratedPrescriptionDefinitionModel> | null;
    'prescriptionGroupId'?: string | null;
    'prescriptionInsuranceCarrier'?: string | null;
    'prescriptionInsurancePhone'?: string | null;
    'prescriptionMemberId'?: string | null;
    'prescriptionPcn'?: string | null;
    'priorTherapies'?: string | null;
    'provider'?: CoverMyMedsV1ClientGeneratedProviderModel | null;
    'providerSignatureDate'?: Moment;
    'samplePackProvidedDate'?: Moment | null;
    'secondaryMedicalCardId'?: string | null;
    'secondaryMedicalGroupId'?: string | null;
    'secondaryMedicalInsuranceCarrier'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsV1ClientGeneratedHubEnrollmentModel>> = [
        {
            "name":     "substitutionsAllowed",
            "baseName": "substitutionsAllowed",
            "type":     "boolean"
        },
        {
            "name":     "caregiver",
            "baseName": "caregiver",
            "type":     "CoverMyMedsV1ClientGeneratedCaregiverModel"
        },
        {
            "name":     "diagnosis",
            "baseName": "diagnosis",
            "type":     "string"
        },
        {
            "name":     "diagnosisDate",
            "baseName": "diagnosisDate",
            "type":     "Date"
        },
        {
            "name":     "otherDiagnosis",
            "baseName": "otherDiagnosis",
            "type":     "string"
        },
        {
            "name":     "drugAllergies",
            "baseName": "drugAllergies",
            "type":     "string"
        },
        {
            "name":     "hasPatientRepresentative",
            "baseName": "hasPatientRepresentative",
            "type":     "boolean"
        },
        {
            "name":     "hcpHasPreferredSpecialtyPharmacy",
            "baseName": "hcpHasPreferredSpecialtyPharmacy",
            "type":     "boolean"
        },
        {
            "name":     "hcpPreferredSpecialtyPharmacy",
            "baseName": "hcpPreferredSpecialtyPharmacy",
            "type":     "string"
        },
        {
            "name":     "isEnrollmentCopayConsented",
            "baseName": "isEnrollmentCopayConsented",
            "type":     "boolean"
        },
        {
            "name":     "isPrescriptionSentToSpecialtyPharmacy",
            "baseName": "isPrescriptionSentToSpecialtyPharmacy",
            "type":     "boolean"
        },
        {
            "name":     "isTcpaConsented",
            "baseName": "isTcpaConsented",
            "type":     "boolean"
        },
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "medicalCardId",
            "baseName": "medicalCardId",
            "type":     "string"
        },
        {
            "name":     "medicalGroupId",
            "baseName": "medicalGroupId",
            "type":     "string"
        },
        {
            "name":     "medicalInsuranceCarrier",
            "baseName": "medicalInsuranceCarrier",
            "type":     "string"
        },
        {
            "name":     "noKnownDrugAllergies",
            "baseName": "noKnownDrugAllergies",
            "type":     "boolean"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "CoverMyMedsV1ClientGeneratedPatientModel"
        },
        {
            "name":     "patientMarketingSignatureDate",
            "baseName": "patientMarketingSignatureDate",
            "type":     "Date"
        },
        {
            "name":     "patientSignatureDate",
            "baseName": "patientSignatureDate",
            "type":     "Date"
        },
        {
            "name":     "patientCopaySignatureDate",
            "baseName": "patientCopaySignatureDate",
            "type":     "Date"
        },
        {
            "name":     "patientSignatureReceivedDate",
            "baseName": "patientSignatureReceivedDate",
            "type":     "Date"
        },
        {
            "name":     "pdf",
            "baseName": "pdf",
            "type":     "string"
        },
        {
            "name":     "preferredContact",
            "baseName": "preferredContact",
            "type":     "string"
        },
        {
            "name":     "preferredLang",
            "baseName": "preferredLang",
            "type":     "Array<string>"
        },
        {
            "name":     "preferredLangOther",
            "baseName": "preferredLangOther",
            "type":     "string"
        },
        {
            "name":     "prescriptionBin",
            "baseName": "prescriptionBin",
            "type":     "string"
        },
        {
            "name":     "prescriptionDefinitions",
            "baseName": "prescriptionDefinitions",
            "type":     "Array<CoverMyMedsV1ClientGeneratedPrescriptionDefinitionModel>"
        },
        {
            "name":     "prescriptionGroupId",
            "baseName": "prescriptionGroupId",
            "type":     "string"
        },
        {
            "name":     "prescriptionInsuranceCarrier",
            "baseName": "prescriptionInsuranceCarrier",
            "type":     "string"
        },
        {
            "name":     "prescriptionInsurancePhone",
            "baseName": "prescriptionInsurancePhone",
            "type":     "string"
        },
        {
            "name":     "prescriptionMemberId",
            "baseName": "prescriptionMemberId",
            "type":     "string"
        },
        {
            "name":     "prescriptionPcn",
            "baseName": "prescriptionPcn",
            "type":     "string"
        },
        {
            "name":     "priorTherapies",
            "baseName": "priorTherapies",
            "type":     "string"
        },
        {
            "name":     "provider",
            "baseName": "provider",
            "type":     "CoverMyMedsV1ClientGeneratedProviderModel"
        },
        {
            "name":     "providerSignatureDate",
            "baseName": "providerSignatureDate",
            "type":     "Date"
        },
        {
            "name":     "samplePackProvidedDate",
            "baseName": "samplePackProvidedDate",
            "type":     "Date"
        },
        {
            "name":     "secondaryMedicalCardId",
            "baseName": "secondaryMedicalCardId",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalGroupId",
            "baseName": "secondaryMedicalGroupId",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalInsuranceCarrier",
            "baseName": "secondaryMedicalInsuranceCarrier",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsV1ClientGeneratedHubEnrollmentModel.attributeTypeMap;
    }
}
